<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
<!--头部-->
      <div class="toolbar" style="height: 63px;">
        <div style="width: 12%;display: flex;flex:1;align-items: center;">
          <div style="font-size: 18px;color: #2F374B;;min-width: 50px">
            名称：
            {{form.appName}}
          </div>
        </div>
        <div style="flex:1;position: absolute; right: 20px;">
          <div style=" display: flex">
            <el-button
                style="border-radius: 20px;font-size: 14px;color: #4D78FF;border-color: #4D78FF;margin-right: 6%"
                size="small ">
              {{typeName}}</el-button>
            <div style="display: flex;align-items: center;">
              <i class="el-icon-close" style="margin: auto;color: #4D78FF;font-size: 26px;cursor: pointer" @click="leave"></i>
            </div>
          </div>
        </div>
      </div>
<!--body-->
      <div style="padding: 22px 0">
        <el-form-item label="上传开发文件" prop="moduleFile">
          <div style="float: left">
          <span v-show="fileName === ''" style="color:#999999;font-size: 14px;margin: 0 5px">未选择文件</span>
          <span v-show="fileName !== null" style="color:#999999;font-size: 14px;margin: 0 5px">{{fileName}}</span>
          <span v-show="fileName !== null" style="color:#999999;font-size: 14px;margin: 0 5px"  @click="uploadDownload()">
              <a href="#" style="color: #4D78FF">已上传的文件下载</a>
            </span>
          </div>
          <el-progress style="width:246px" v-if="showProgress" :percentage="percentage"></el-progress>
        </el-form-item>
        <el-form-item label="调用周期" prop="invokePeriod">
          <el-input oninput="value=value.replace(/[^\d]/g,'')" maxlength=20 v-model.number="form.invokePeriod" :disabled="isDisabled" style="width: 556px !important;" size="small" placeholder="请输入调用周期">
            <template slot="append">ms</template>
          </el-input>
          <el-popover
              placement="top"
              title=""
              width="160"
              trigger="hover"
              content="APP应用Step方法被调用的周期，单位毫秒">
            <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="预期执行时长" prop="expectExectime">
          <el-input  oninput="value=value.replace(/[^\d]/g,'')" maxlength=20 v-model.number="form.expectExectime" :disabled="isDisabled" style="width: 556px !important;" size="small" placeholder="请输入预期执行时长">
            <template slot="append">ms</template>
          </el-input>
          <el-popover
              placement="top"
              title=""
              width="160"
              trigger="hover"
              content="算法Step方法预期的执行时长，不应大于该算法的调用周期。（仿真系统为了保证场景的可复现性，无论算法每次实际运行时长为多少，对于该算法发出的消息而言，保证在算法预期执行时长结束之前不会被其他算法所见；而在预期结束时长结束之后会立即被其他算法可见）">
            <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="仿真加速倍数" prop="playControlRate">
          <el-input  oninput="value=value.replace(/[^\d]/g,'')" maxlength=4 v-model.number="form.playControlRate"  :disabled="isDisabled" style="width: 526px !important;" size="small" placeholder="请输入仿真加速倍数">
            <template slot="append">%</template>
          </el-input>
          <el-popover
            placement="top"
            title=""
            width="160"
            trigger="hover"
            content="100%为原始仿真速率，百分比值越大，速度越慢；比值越小，速度越快。如设置为10%则为仿真加速10倍">
            <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="接入模式" prop="accessMode">
          <el-radio-group v-model="form.accessMode" :disabled="isDisabled">
            <el-radio :label="0">可执行文件</el-radio>
            <el-radio :label="1">动态链接库</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="form.accessMode === 0 ? '可执行文件路径': '动态链接库路径'" prop="mainPath">
          <el-input v-model="form.mainPath" style="width: 556px !important;" :disabled="isDisabled" type="text" size="small" :placeholder="form.accessMode === 0 ? '请输入在文件夹中的可执行文件路径：如bin\\bin.dll': '请输入在文件夹中的动态链接库路径：如bin\\bin.dll'"></el-input>
          <el-popover
              placement="top"
              title=""
              width="160"
              trigger="hover"
              content="对应“可执行文件”接入模式。填写可执行文件在用户解压算法包后的相对路径。字符串格式。例如：planning/libsim_planning.so">
            <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="依赖路径" prop="dependentPath">
          <el-input v-model="form.dependentPath" style="width: 556px !important;" :disabled="isDisabled" type="textarea" size="small" placeholder="请输入依赖路径可','分割支持多个"></el-input>
          <el-popover
              placement="top"
              title=""
              width="160"
              trigger="hover"
              content="自动启动模块时模块程序的依赖库搜索路径，应填写解压算法包后的相对路径，路径为以“,”分隔的字符串，例如：.\bin.dll">
            <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <el-form-item :label="'可执行文件参数'">
          <el-input v-model="form.binArgs" style="width: 556px !important;" :disabled="isDisabled" type="textarea" size="small" placeholder="请输入可执行文件参数,可','分割支持多个" ></el-input>
            <el-popover
              placement="top"
              title=""
              width="160"
              trigger="hover"
              content="对应“可执行文件”接入模式，所填写字段与所执行的算法脚本一致。数组格式：例如：['--app_name', 'Traffic', '--ip_addr_port', '']。以py脚本为例，Python执行命令一般使用 'python xxx.py --key value'，那么该栏填写python的命令行参数，'['xxx.py', '--key', 'value']'">
            <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="初始化参数">
          <el-input v-model="form.initargs" style="width: 556px !important;" :disabled="isDisabled" type="textarea" size="small" placeholder="请输入初始化参数,可';'分割支持多个"></el-input>
        </el-form-item>
        <el-form-item label="执行超时时间">
          <el-input v-model.number="form.execTimeout" style="width: 556px !important;" :disabled="isDisabled" size="small" placeholder="请输入执行超时时间">
            <template slot="append">ms</template>
          </el-input>
          <el-popover
              placement="top"
              title=""
              width="160"
              trigger="hover"
              content="算法执行仿真定义的接口函数时的最大超时时间。">
            <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="单步超时时间">
          <el-input v-model.number="form.onestepTimeout" style="width: 556px !important;" :disabled="isDisabled" size="small" placeholder="请输入单步超时时间">
            <template slot="append">ms</template>
          </el-input>
          <el-popover
              placement="top"
              title=""
              width="160"
              trigger="hover"
              content="算法Step方法的最大超时时间。">
            <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <div style="height: 1px; width: 100%;background: #c0c4cc;margin: 20px 0;"></div>
        <div>
          <el-form-item label="算法配置">
            <Algorithm :list="moduleDataList" :dataList="moduleDataList" :moduleDataValue="moduleDataValue" :isDisabled="isDisabled"></Algorithm>
          </el-form-item>
        </div>
        <el-form-item label="仿真场景">
          <el-cascader
            v-model="sceneSetTreeValue"
            :options="sceneSetTree"
            :props="sceneSetTreeProps"
            style="width: 556px !important"
            collapse-tags
            clearable
            :disabled="isDisabled" >
          </el-cascader>
        </el-form-item>
        <el-form-item label="指标组" prop="indicatorGroupId">
           <el-select v-model="form.indicatorGroupId" placeholder="请选择" :disabled="isDisabled" >
            <el-option
              v-for="item in indicatorGroupList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getDetails, getSceneSetTree, getModuleList, getIndicatorGroupList } from '@/api/modules/major'
import { mapGetters } from 'vuex'
import Algorithm from '@/components/algorithm'
export default {
  components: {
    Algorithm
  },
  data() {
    return {
      appId: this.$route.query.id,
      showProgress: false,
      percentage: 0,
      form: {
        id: null,
        moduleId: '',
        moduleConfigId: '',
        catalogueId: this.$route.query.catalogueId,
        appName: '',
        appDesc: '',
        sceneSetid: '',
        sceneId: '',
        invokePeriod: null,
        expectExectime: null,
        accessMode: 0,
        mainPath: '',
        dependentPath: '',
        binArgs: '',
        initargs: '',
        execTimeout: '',
        onestepTimeout: '',
        moduleKey: '',
        moduleFile: '',
        appStage: 0,
        playControlRate: 100
      },
      command: null,
      fileListAttr: [],
      fileList: '',
      fileName: '',
      appStatus: { appStage: -1, stageStatus: 0 },
      isDisabled: true,
      sceneSetTree: [],
      moduleDataList: [],
      moduleDataValue: [],
      sceneSetTreeValue: [],
      indicatorGroupList: [],
      sceneSetTreeProps: {
        multiple: true,
        value: 'id',
        label: 'name',
        children: 'scenes'
      }
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userAuth/getUsersCurrentInfo'
    }),
    showPage() {
      return !!this.userInfo || this.$route.meta.noAuth
    },
    typeName() {
      if (this.form.appStage === 1) {
        return 'SIL测试'
      }
      if (this.form.appStage === 2) {
        return 'HIL测试'
      }
      if (this.form.appStage === 3) {
        return '车辆测试'
      }
      if (this.form.appStage === 4) {
        return '发布'
      }
      else {
        return '开发中'
      }
    }
  },
  watch: {
  },
  async created() {
    this.getSceneSetTree()
    this.getModuleList()
    this.getIndicatorGroupList()
    if (this.appId !== '' && this.appId !== null && this.appId !== undefined) {
      this.form.id = this.appId
      this.getDetails()
    }
  },
  methods: {
    async getDetails() {
      const res = await getDetails({ id: this.form.id })
      if (res.code === 0) {
        this.form = res.data
        if (res.data.sceneSetid !== '' && res.data.sceneSetid !== null) {
          this.getSceneList(res.data.sceneSetid)
        }
        if (res.data.stageStatus !== 0 && res.data.stageStatus !== 1) {
          this.isDisabled = true
        }
        this.fileName = res.data.moduleKey
        this.fileList = [{ name: res.data.moduleFile, url: 'http://' + res.data.moduleFile }]
        this.moduleDataValue = res.data.moduleIds.split(',').map(Number)
        this.sceneSetTreeValue = JSON.parse(res.data.sceneIds)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    uploadDownload() {
      window.location = `/capi/web-service/uaes/commons/download?objectKey=${this.form.moduleKey}`
    },
    leave() {
      this.$router.go(-1)
      this.$message({
        type: 'success',
        message: '退出成功'
      })
    },
    // 查询场景集树
    async getSceneSetTree() {
      const res = await getSceneSetTree()
      if (res.code === 0) {
        this.sceneSetTree = res.data.list
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 查询算法列表
    async getModuleList() {
      const res = await getModuleList()
      if (res.code === 0) {
        this.moduleDataList = res.data.list
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async getIndicatorGroupList() {
      const res = await getIndicatorGroupList()
      if (res.code === 0) {
        this.indicatorGroupList = res.data.list
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style scoped>
/deep/.el-radio__input.is-checked+.el-radio__label{
  color: #4D78FF;
}
/deep/.el-radio__input.is-checked .el-radio__inner{
  background: white;
}/deep/.el-radio__inner{
  width: 16px;
  height: 16px;
 }
/deep/.el-radio__inner::after{
  width: 10px;
  height: 10px;
  background-color: #4D78FF;
}
.toolbar {
  background-color: #fff;
  display: flex;
  box-sizing: border-box;
  padding: 15px 0;
  width: 100%;
  border-bottom: 1px solid #DDDDDD;
  /*z-index: 3;*/
  /*position: absolute;*/
  align-items:center;
}
.toolbar .command:nth-of-type(1) {
  margin-left: 24px;
}
.toolbar .command {
  font-size: 24px;
  /*box-sizing: border-box;*/
  width: 27px;
  height: 27px;
  /*margin: 0px 6px;*/
  /*border-radius: 2px;*/
  padding-left: 6px;
  /*display: inline-block;*/
  /*border: 1px solid rgba(2, 2, 2, 0);*/
}
.toolbar .command:hover {
  cursor: pointer;
  /*font-size: 28px;*/
  /*border: 1px solid #e9e9e9;*/
}
.toolbar .disable {
  color: rgba(0, 0, 0, 0.25);
}
.toolbar .separator {
  margin: 4px;
  border-left: 1px solid #e9e9e9;
}

/*/deep/#name{*/
/*  border-radius: 4px !important;*/
/*}*/
/deep/.el-dialog__title{
  font-size: 18px;
  font-weight: bold;
}
/deep/.el-dialog__header{
  padding: 40px 20px 0;
}
/deep/.el-dialog__footer{
  padding: 50px 20px 40px;
}
.onWork_line{
  border:2px solid #4D78FF;
}
.line{
  border:2px solid #DDDDDD;
}
.onInit{
  border: 5px solid #B8C9FF;
}
.onOver{
  border: 5px solid #4D78FF;
}
.onWork{
  border: 5px solid #49A37D;
}
/deep/.el-drawer__container{
  overflow-x: hidden;
}
/deep/ .el-form-item__label{
  line-height: 32px;
}
/deep/ .el-form-item__content{
  line-height: 32px;
}
/*/deep/ .el-form-item{*/
/*  margin-bottom: 9px;*/
/*}*/
/*/deep/ .el-form-item__error{*/
/*  display:none;*/
/*}*/
.cancelButton{
  border-color: #4d78ff;
  width: 96px;
  height: 40px
}
.confirmButton{
  color: #fff;
  background-color: #4d78ff;
  border-color: #4d78ff;
  width: 96px;
  height: 40px
}
.waitStatus{
  background-color: #F5F6F8;
  border: 1px solid #DDDDDD;
  color:#A7A7A7;
  border-radius: 12.5px;
  padding: 4px 0;
  width: 80%;
  margin: auto
}
.status{
  background-color: #EDFFEE;
  border: 1px solid #09D589;
  color:#09D589;
  border-radius: 12.5px;
  padding: 4px 6px;
  /*width: 80%;*/
  margin: auto
}
::v-deep .el-upload-list__item{
  width:80px;
  height:80px;
}
::v-deep .el-upload--picture-card{
  width:80px;
  height:80px;
  line-height:86px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-thumb {
  background: rgb(220 225 225 / 65%);
  cursor: pointer;
  border-radius: 4px;
}
</style>
